
import { useSearchParams } from "react-router-dom";
import useWindowDimensions from "./useWindowDimensions";
import { useSelector } from "react-redux";
import LocalStorageService from "../common/services/LocalStorageService";
import Utils from "../utils";

const doSearch = (value, cb, cancelDebounce) => {
  if (!cancelDebounce) {
    cb({
      page: 1,
      per_page: 10,
      search: value ? value : undefined,
    });
  }
};
const debouncedSearch = Utils?.debounce(doSearch, 500);

export default function useStep1(searchVal,setSearchVal) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { width, isMobile, isSmallMobile } = useWindowDimensions();
  const { isAuthenticated } = useSelector((state) => state?.auth);
  const is_search_limit_reached = LocalStorageService?.get("search_count") >= 7 && !isAuthenticated

  const setUrlSearchParams = (newParams) => {
    const filteredSearchParams = Utils?.get_filtered_url_params(searchParams, {
      search: searchParams?.get("search") ? searchParams?.get("search") : undefined,
      page: searchParams?.get("page") ? searchParams?.get("page") : 1,
      per_page: searchParams?.get("per_page")
        ? searchParams?.get("per_page")
        : 10,
      category: searchParams?.get("category") ? searchParams?.get("category") : undefined,
      own_only: searchParams?.get("own_only")
        ? searchParams?.get("own_only")
        : undefined,
      ...newParams,
    });
    setSearchParams(filteredSearchParams);
  };

  const onSearch = (value, cancelDebounce) => {
    if (!cancelDebounce) {
      setSearchVal(value);
    }
    debouncedSearch(
      value,
      () => {
        setUrlSearchParams({
          page: 1,
          per_page: 10,
          search: value ? value : undefined,
        });
      },
      cancelDebounce
    );
  };

  return {
    onSearch,
    setUrlSearchParams,
    is_search_limit_reached,
    width,
    isMobile,
    isSmallMobile,
  };
}
